import { Alert, Stack } from '@mui/material'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { DiffViewer } from '@/features/controller/configuration/components/textEditor/DiffViewer'
import type { TextEditorLanguage } from '@/features/controller/configuration/types'

type ConfigFileChangeReviewProps = {
  /** A save conflicted, so the base is a version saved meanwhile, which the change would overwrite */
  baseReplaced: boolean
  header?: ReactNode
  language: TextEditorLanguage
  modifiedText: string
  originalText: string
}

/** One file's change in a {@link ConfigReviewDialog} */
export function ConfigFileChangeReview({
  baseReplaced,
  header,
  language,
  modifiedText,
  originalText,
}: Readonly<ConfigFileChangeReviewProps>) {
  const { t } = useTranslation()

  return (
    <Stack gap={1}>
      {header}
      {baseReplaced && <Alert severity="warning">{t('controllers.configuration.review_dialog.base_replaced')}</Alert>}
      <DiffViewer fitToChanges={true} language={language} modifiedText={modifiedText} originalText={originalText} />
    </Stack>
  )
}
